import { ConnectButton } from '@rainbow-me/rainbowkit'
import bg from './imgs/bg.png'
import fg from './imgs/lander.gif'

import dd from './imgs/dd.png'
import React from 'react'
import Web3 from 'web3'

import {
	useAccount,
	useChainId
} from 'wagmi'

const berasABI = require("./abis/beras.json")
const BERAS = "0xccEA61b327F074d777ebB9AffdaF5581bca10918"
const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.berachain.com'));
const beras = new web3.eth.Contract(berasABI, BERAS)

export function Web3App (props) {

	const { address, isConnected } = useAccount()
	const chainId  = useChainId()
	const [style, setStyle] = React.useState({backgroundImage: `url(${fg})`})
	const [bal, setBal] = React.useState(0)
	const [activeIndex, setActiveIndex] = React.useState(999)
	const [activeID, setActiveID] = React.useState(2001)
	const [activeImage, setActiveImage] = React.useState("")

	React.useEffect(
		() => {
		if (isConnected) {
			setStyle({backgroundImage: `url(${bg})`})
			getBal()
		} else {
			setStyle({backgroundImage: `url(${fg})`})
		}
		},
		[isConnected]
		)
	React.useEffect(()=>{
		if (isConnected) {
			getBal()
		}
	},[isConnected])

	React.useEffect(()=>{
		if (Number(bal) > 0) {
			setActiveIndex(0)
		}
	}, [bal])

	React.useEffect(()=>{
		getTokenIdByIndex()
	},[activeIndex])

	React.useEffect(()=>{
		getMetadata()
	},[activeID])

	const getBal = () => {
	  	if (isConnected) {
	  		beras.methods.balanceOf(address)
	  		.call({from: address})
	  		.then((balance)=>{
	  			setBal(balance)
	  		})
	  	} else {
	  		console.log("balance call failed")
	  	}
	  }

	const next = () => {
		if (activeIndex < Number(bal) - 1 && activeIndex != 999) {
			setActiveIndex(activeIndex + 1)
		}
	}

	const prev = () => {
		if (activeIndex > 0 && activeIndex != 999) {
			setActiveIndex(activeIndex - 1)
		}
	}


	const getTokenIdByIndex = () => {
		if (activeIndex < 999) {
			beras.methods.tokenOfOwnerByIndex(address, activeIndex)
				.call({from: address})
				.then((id)=>{
					setActiveID(id)
				})
			}
	}

	
	const getMetadata = () => {
		if (activeID < 2001) {
			fetch("https://ipfs.io/ipfs/bafybeibswb5jqpw7br6f6o22a2rg6vjgzjvgnf63zqr45nwznfzhokfxvq/" + activeID + ".json")
				.then((response)=>{
					console.log(response)
					response.json()
						.then((json) =>{
							console.log(json.image)
							setActiveImage(json.image.replace("ipfs://", "https://ipfs.io/ipfs/"))
						})
				})
		}
	}

  return (
  	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
	  	<div className="bg" style={style}>
	  		
	  		<div className="mint-box">
	  			<h2 className="derp-number">Derpe Bera #{activeID}</h2>
	  			<div className="mint-gif">
	  				<img src={activeImage} />
	  			</div>
	  			<div className="change-nft">
	  				<button onClick={prev}>back</button>
	  				<span>{activeIndex}</span>
	  				<button onClick={next}>next</button>
	  			</div>
	  			<p className="bal">You have {bal} beras</p>
	  		</div>
	  		
	  		
	  
	  		<div className="dd"><img src={dd}/></div>
	  		<div className="connect-button">
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>
	  	</div>
  	</div>
  	)
};